export const PROFILE_AVATAR_UPLOAD_REQUEST = 'profile/avatar-upload-request'
export const PROFILE_AVATAR_UPLOAD_SUCCESS = 'profile/avatar-upload-success'
export const PROFILE_AVATAR_UPLOAD_FAILED = 'profile/avatar-upload-failed'
